module.exports = __webpack_public_path__ + "img/emptydetails.41abfd2c.svg";